import { BoxV2 as Box } from 'portal-commons';
import { FunctionComponent } from 'react';

interface FormGridLayoutProps {
  rowGap?: string;
  columnGap?: string;
}

const FormGridLayout: FunctionComponent<FormGridLayoutProps> = ({
  rowGap = 's',
  columnGap = 'xxl',
  children,
}) => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      rowGap,
      columnGap,
    }}
  >
    {children}
  </Box>
);

export default FormGridLayout;
